import PropTypes from 'prop-types';
import {useCallback, useMemo} from 'react';
import useLabels from 'infrastructure/js/hooks/useLabels';
import TextField from 'infrastructure/js/components/controls/TextField/textField';
import Validation from 'infrastructure/js/components/controls/controlsValidations.js';
import Normalize from 'infrastructure/js/components/controls/controlsNormalizations';
import withPortal from 'infrastructure/js/components/HOCs/withPortal/withPortal';
import UnitHelper, {unitTypes} from 'infrastructure/js/utils/uomHelper';
import EntitiesMultiSelect from '../../../EntitiesMultiSelect/entitiesMultiSelect';

import './assetLengthListItem.scss';

const EntitiesMultiSelectPortal = withPortal(EntitiesMultiSelect);

const PORTAL_CLASS_NAMES = { menuPortal: () => 'assets-select-menu-portal' };


export default function AssetLengthListItem({ name,
                           index,
                           assetType,
                           change,
                           touch,
                           fetchConfig,
                           fieldData,
                           allFieldsData,
}) {

  const validationLabels = useLabels('mat.validation.messages.');

  const lengthLeft = fieldData?.asset?.assetsValue?.data?.lengthLeft ?? 0;
  const maxLength = UnitHelper.serverValueToUserValue(unitTypes.LENGTH, lengthLeft, 2);


  const entitiesTypes = useMemo(() => [assetType], [assetType]);

  const singleSelectionValidation = useCallback((value, allValues) => {
    const id = value?.value;
    const allIds = allFieldsData?.map(item => item?.asset?.assetsValue?.value) ?? [];
    const isDuplicated = allIds.some((item, itenIndex) => {
      return item === id && itenIndex !== index;
    });

    if (isDuplicated) {
      touch(`${name}.[asset].assetsValue`);
      return validationLabels.get('duplicatedSelection');
    }

    return undefined;
  }, [index, allFieldsData]);

  const validate = useMemo(() => [Validation.required, singleSelectionValidation], [singleSelectionValidation]);

  const onValueChangeCallback = useCallback((newValue, oldValue) => {
    // If cleared explicitly, reset length
    if (newValue === null) {
      change(`${name}.length`, null);
      return;
    }

    const newVal = newValue?.value;
    const oldVal = oldValue?.value;

    // No change - prevent clearing
    if (newVal === oldVal) {
      return;
    }

    change(`${name}.length`, null);
  }, [name, change]);


  return (
    <div className='asset-length-list-item'>
      <EntitiesMultiSelectPortal
        id={name + '.[asset]'}
        name={name + '.[asset]'}
        entitiesTypes={entitiesTypes}
        fetchConfig={fetchConfig}
        change={change}
        showEntitiesTypes={false}
        isMulti={false}
        validate={validate}
        onValueChangeCallback={onValueChangeCallback}
        classNames={PORTAL_CLASS_NAMES}
      />
      <TextField id={name + '.[length]'}
                 name={name + '.[length]'}
                 className="asset-length"
                 normalize={Normalize.normalizeFloat(0, parseFloat(maxLength))}
                 validate={Validation.required}
                 placeholder={`${maxLength ? '0-' + parseFloat(maxLength) : 0} `}
      />
      </div>
  )
}

AssetLengthListItem.propTypes = {
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  assetType: PropTypes.string.isRequired,
  touch: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  fetchConfig: PropTypes.object.isRequired,
  fieldData: PropTypes.object,
  allFieldsData: PropTypes.array.isRequired,
};
